import api from 'api/axiosInstance';
import { getLocationOrigin } from 'utils/helpers';
import { SubscriptionPlanNameEnum } from 'types/users.types';

type Params = {
  planId: string;
  promocode?: string;
  nickname: SubscriptionPlanNameEnum;
};

const createCheckoutSession = ({
  planId,
  promocode,
  nickname,
}: Params): Promise<{ id: string }> =>
  api.post('/v1/subscriptions/stripe/subscribe', {
    priceId: planId,
    success_url:
      nickname === SubscriptionPlanNameEnum.e_invoicing1 ||
      nickname === SubscriptionPlanNameEnum.e_invoicing12
        ? `${getLocationOrigin(true)}/revenues?ps=true`
        : `${getLocationOrigin(true)}/expenses?ps=true`,
    cancel_url: `${getLocationOrigin(true)}/paymentFailed`,
    promocode,
  });
export default createCheckoutSession;
